/** Selected-city gates for Settings chrome. Do not use a user-level alias. */

export function documentManagementEnabled(
  municipality: { document_management?: boolean } | null | undefined
): boolean {
  return municipality?.document_management === true;
}

export function documentManagementFlagged(
  municipality: { document_management_flagged?: boolean } | null | undefined
): boolean {
  return municipality?.document_management_flagged === true;
}

export function teamManagementEnabled(
  municipality: { team_management?: boolean } | null | undefined
): boolean {
  return municipality?.team_management === true;
}

export function adminSettingsEnabled(
  municipality:
    | { document_management?: boolean; team_management?: boolean }
    | null
    | undefined
): boolean {
  return documentManagementEnabled(municipality) || teamManagementEnabled(municipality);
}
